import React, { useState } from "react";
import "./mailbox_styles/sidebar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faInbox,
  faEnvelopeCircleCheck,
  faStar,
  faPencil,
  faTrash,
  faFileCircleXmark
} from "@fortawesome/free-solid-svg-icons";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const Sidebar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const currentMailOption = currentPath.split("/")[2];

  const [active_mailOption, setActive_mailOption] = useState(currentMailOption);
  const inboxCount = useSelector((state) => state.inboxCount);

  const handleClickMailOption = (mailOption) => {
    setActive_mailOption(mailOption);
  }

  return (
    <>
      <div className="sidebar_container">
        <h2 className="title">Mailbox</h2>
        <Link to="/mailbox/new-mail" className="link">
          <div className="newMessage_btn">
            <FontAwesomeIcon icon={faEnvelope} />
            <span className="newMessage">New Mail</span>
          </div>
        </Link>
        <div className="mailbox_options">
          <Link to="/mailbox/inbox" className="link">
            <div className={` mailbox_option ${active_mailOption === "inbox" ? "active_mailOption" : ""
              }`} onClick={() => handleClickMailOption("inbox")}>
              <div>
                <FontAwesomeIcon icon={faInbox} className="mailbox_icon" />
                <span className="mail_optionName">Inbox</span>
              </div>
              <span className="mail_optionNumber" style={{ display: inboxCount > 0 ? "" : "none" }}>{inboxCount}</span>
            </div>
          </Link>
          <Link to="/mailbox/sent-mails" className="link">
            <div className={` mailbox_option ${active_mailOption === "sent-mails" ? "active_mailOption" : ""
              }`} onClick={() => handleClickMailOption("sent-mails")}>
              <div>
                <FontAwesomeIcon icon={faEnvelopeCircleCheck} className="mailbox_icon" />
                <span className="mail_optionName">Sent Emails</span>
              </div>
              <span></span>
            </div>
          </Link>
          <Link to="/mailbox/starred" className="link">
            <div className={` mailbox_option ${active_mailOption === "starred" ? "active_mailOption" : ""
              }`} onClick={() => handleClickMailOption("starred")}>
              <div>
                <FontAwesomeIcon icon={faStar} className="mailbox_icon" />
                <span className="mail_optionName">Starred</span>
              </div>
              <span></span>
            </div>
          </Link>
          <Link to="/mailbox/draft" className="link">
            <div className={` mailbox_option ${active_mailOption === "draft" ? "active_mailOption" : ""
              }`} onClick={() => handleClickMailOption("draft")}>
              <div>
                <FontAwesomeIcon icon={faPencil} className="mailbox_icon" />
                <span className="mail_optionName">Draft</span>
              </div>
              <span></span>
            </div>
          </Link>
          <Link to="/mailbox/deleted-mails" className="link">
            <div className={` mailbox_option ${active_mailOption === "deleted-mails" ? "active_mailOption" : ""
              }`} onClick={() => handleClickMailOption("deleted-mails")}>
              <div>
                <FontAwesomeIcon icon={faTrash} className="mailbox_icon" />
                <span className="mail_optionName">Deleted</span>
              </div>
              <span></span>
            </div>
          </Link>
          <Link to="/mailbox/spam-mails" className="link">
            <div className={` mailbox_option ${active_mailOption === "spam-mails" ? "active_mailOption" : ""
              }`} onClick={() => handleClickMailOption("spam-mails")}>
              <div>
                <FontAwesomeIcon icon={faFileCircleXmark} className="mailbox_icon" />
                <span className="mail_optionName">Spam</span>
              </div>
              <span></span>
            </div>
          </Link>
        </div>
      </div>
      <Outlet />
    </>
  );
};

export default Sidebar;
